export default "__VITE_ASSET__8aaf0426__"